<template>
    <v-row
        class="footer-items d-flex flex-warp"
    >
        <v-col
            v-for="(item, index) in items"
            :key="item.id ?? index"
            class="footer-dim-items nav-items-col"
            cols="12"
            md="auto"
        >
            <v-list
                class="footer-top-menu-list bg-transparent"
                width="max-content"
                role="contentinfo"
            >
                <v-list-item-subtitle
                    class="menu-list-header top-menu-list-header px-2"
                    :class="{ 'text-uppercase': !noUppercaseTitle }"
                    role="heading"
                    aria-level="2"
                >
                    <NuxtLink
                        v-if="item.path && !noLinkTitle"
                        :to="item.path"
                        class="text-anchor"
                        :aria-label="item.label"
                        role="link"
                    >
                        <strong>{{ item.label }}</strong>
                    </NuxtLink>
                    <strong
                        v-else
                    >
                        {{ item.label }}
                    </strong>
                </v-list-item-subtitle>
                <template
                    v-for="child in item.items || []"
                    :key="`child-${child.id ?? index}`"
                >
                    <v-list-item
                        v-if="child.path"
                        :key="`child-path-item-${child.id ?? index}`"
                        :to="child.path"
                        class="menu-list-item px-2 py-0 my-0"
                        min-height="fit-content"
                        max-height="fit-content"
                        :aria-label="child.label"
                        role="link"
                        exact
                    >
                        {{ child.label }}
                    </v-list-item>
                    <v-list-item
                        v-else-if="child.url"
                        :key="`child-url-item-${child.id ?? index}`"
                        class="menu-list-item px-2 py-0 my-0"
                        min-height="fit-content"
                        max-height="fit-content"
                        :aria-label="child.label"
                        role="link"
                        exact
                    >
                        <a
                            class="text-anchor text-decoration-none"
                            :href="child.url"
                        >
                            {{ child.label }}
                        </a>
                    </v-list-item>
                </template>
            </v-list>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
    import type { MenuItem } from '~/types';

    const props = defineProps<{
        items: Nilish<MenuItem[]>;
        noLinkTitle?: boolean;
        noUppercaseTitle?: boolean;
    }>();
</script>

<style lang="scss">
.footer-items {
    .v-list-item__content {
        font-size: 92%;
    }

    .menu-list-header {
        opacity: 1;
    }

    .nav-items-col {
        max-width: 33%;
        max-width: fit-content;
    }

    .menu-list-item {
        padding-top: 0.4rem !important;
        padding-bottom: 0.4rem !important;
    }

    .v-list-item-subtitle {
        height: 32px !important;
        min-height: 32px !important;
        white-space: nowrap;
    }
}
</style>
